import { NgModule, APP_INITIALIZER } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";

import "hammerjs";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";

import { CoreModule } from "@core/core.module";
import { CoreCommonModule } from "@core/common.module";
import { CoreSidebarModule, CoreThemeCustomizerModule } from "@core/components";

import { coreConfig } from "app/app-config";

import { AppComponent } from "app/app.component";
import { LayoutModule } from "app/layout/layout.module";

import { JwtInterceptor } from "./auth/helpers/jwt.interceptor";

import { HashLocationStrategy, LocationStrategy } from "@angular/common";
import { AppRoutingModule } from "./app-routing.module";
import { MiscellaneousModule } from "./main/pages/miscellaneous/miscellaneous.module";
import { SharedModule } from "./main/shared/shared.module";
import { FullCalendarModule } from "@fullcalendar/angular";
import { AppInitializerService } from "./app.initializer";
import { TimezoneInterceptor } from "app/main/interceptors/timezone.interceptor";
// import { CookieService } from 'ngx-cookie-service';

export function initializeApp(preInitService: AppInitializerService) {
  return (): Promise<void> => {
    return preInitService.executePreInitApp();
  };
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    TranslateModule.forRoot(),

    //NgBootstrap
    NgbModule,

    // Core modules
    CoreModule.forRoot(coreConfig),
    CoreCommonModule,
    CoreSidebarModule,
    CoreThemeCustomizerModule,

    // App modules
    LayoutModule,
    MiscellaneousModule,
    SharedModule,
    FullCalendarModule,
  ],
  providers: [
    AppInitializerService,
    // CookieService,
    {
      provide: APP_INITIALIZER,
      useFactory: (initializer: AppInitializerService) => () =>
        initializer.executePreInitApp(),
      deps: [AppInitializerService],
      multi: true,
    },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: TimezoneInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
